// FilterChip.jsx — VMFIVE Design System
// Phase 1B-3: Pill-shaped toggle chip for filter bars (e.g. AdsList)
//
// Usage:
//   <FilterChip active={filter === 'active'} onClick={() => setFilter('active')} count={12}>
//     Active
//   </FilterChip>

import './FilterChip.css';

/**
 * FilterChip — pill-shaped toggle button for filter bars.
 *
 * @param {object}   props
 * @param {boolean}  [props.active=false]   - Whether this chip is selected (orange fill)
 * @param {Function} [props.onClick]        - Click handler
 * @param {number}   [props.count]          - Optional count shown in parentheses after label
 * @param {boolean}  [props.disabled=false] - Disables interaction
 * @param {string}   [props.className='']   - Extra class names
 * @param {React.ReactNode} props.children  - Label text
 */
export default function FilterChip({
  children,
  active = false,
  onClick,
  count,
  disabled = false,
  className = '',
}) {
  return (
    <button
      type="button"
      className={[
        'ds-filter-chip',
        active ? 'ds-filter-chip--active' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      aria-pressed={active}
      disabled={disabled}
      onClick={onClick}
    >
      <span className="ds-filter-chip__label">{children}</span>
      {count !== undefined && count !== null && (
        <span className="ds-filter-chip__count">({count})</span>
      )}
    </button>
  );
}
